import { string, shape, number, bool, arrayOf } from 'prop-types';

import { picturePropTypes } from './pictures';

export const productsPropTypes = shape({
  stock: bool.isRequired,
  product: shape({
    name: string.isRequired,
    description: string.isRequired,
    pictures: picturePropTypes.isRequired,
    foodType: arrayOf(string).isRequired
  }),
  price: number.isRequired,
  initialPrice: number.isRequired,
  menuDiscount: number.isRequired
});
